import { render, staticRenderFns } from "./StatsTable.vue?vue&type=template&id=74a9012c"
import script from "./StatsTable.vue?vue&type=script&lang=js"
export * from "./StatsTable.vue?vue&type=script&lang=js"
import style0 from "./StatsTable.vue?vue&type=style&index=0&id=74a9012c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports